import { DETALHE_PAGAMENTO, PAGAMENTO, PagamentoActionTypes, PagamentoState } from 'domain/types/_carteira/detalhePagamento/detalhePagamento';

const INITIAL_STATE: PagamentoState = {
  Pagamento: [],
  PagamentoDetalhe: []
};

export function PagamentoReducer(
  state = INITIAL_STATE,
  action: PagamentoActionTypes
): PagamentoState {
  switch (action.type) {
    case PAGAMENTO:
      return { ...state, Pagamento: action.payload as [] };
    case DETALHE_PAGAMENTO:
      return { ...state, PagamentoDetalhe: action.payload as [] };
    default:
      return state;
  }
}